import { ReactComponent as Empty } from "../../../../../common/assets/icons/empty.svg";
import Toggle from "../../../../components/common/toggle";
import CheckBox from "../../../../components/common/checkBox";
import { WordData } from "../../../../../common/hooks/console/management/word/useGetWord";
import { useEffect } from "react";
import { usePutWordStatus } from "../../../../../common/hooks/console/management/word/usePutWordStatus";
import { useAuthStore } from "../../../../store/useAuthStore";

interface WordTableProps {
    data?: WordData[];
    selectedRow: number | null;
    selectedRows: number[];
    onRowClick?: (idx: number) => void;
    onRowSelect?: (selectedIdx: number[]) => void;
}

const WordTable = ({ data, selectedRow, selectedRows, onRowClick, onRowSelect }: WordTableProps) => {
    const level = useAuthStore(state => state.m_level);

    const putWordStatusMutation = usePutWordStatus();
    const handleChangeStatus = (id: number) => {
        const payload = {
            id,
        };
        putWordStatusMutation.mutate(payload);
    };
    const handleRowClick = (idx: number) => {
        onRowClick?.(idx);
    };
    const handleCheckboxChange = (idx: number) => {
        let updatedSelectedRows;
        if (selectedRows.includes(idx)) {
            updatedSelectedRows = selectedRows.filter(id => id !== idx);
        } else {
            updatedSelectedRows = [...selectedRows, idx];
        }

        onRowSelect?.(updatedSelectedRows);
    };

    useEffect(() => {
        onRowSelect?.([]);
    }, [data, onRowSelect]);

    useEffect(() => {
        if (data && data.length > 0) {
            onRowClick?.(data[0].word_idx);
        }
    }, []);

    return (
        <table className="table-auto w-full text-gray2">
            {/* Header */}
            <thead className=" text-sm border-y border-gray3 h-10">
                <tr>
                    <th className="px-3">
                        <CheckBox
                            checked={data?.length ? selectedRows.length === data.length : false}
                            onChange={() => {
                                if (data) {
                                    onRowSelect?.(selectedRows.length === data.length ? [] : data.map(word => word.word_idx));
                                }
                            }}
                        />
                    </th>
                    <th className="px-2 text-start w-1/3">카테고리</th>
                    <th className="px-2 text-start w-1/3">경조사어</th>
                    <th className="px-2 text-start w-1/3">검색어</th>
                    <th className="px-2 text-start min-w-[100px]">노출/숨김</th>
                </tr>
            </thead>
            {/* Body */}
            <tbody>
                {data?.length ? (
                    data?.map((word: any, index) => (
                        <tr
                            key={`${word.product_idx}-${index}`}
                            className={`border-b border-gray4 text-sm h-[50px] cursor-pointer hover:bg-[#E6EEDD] ${
                                selectedRow === word.word_idx ? "bg-[#F9EBEB]" : ""
                            }`}
                            onClick={() => handleRowClick(word.word_idx)}
                        >
                            <td className="px-3" onClick={e => e.stopPropagation()}>
                                <CheckBox
                                    checked={selectedRows.includes(word.word_idx)}
                                    onChange={() => handleCheckboxChange(word.word_idx)}
                                />
                            </td>
                            <td className="px-2">{word.category?.event_name}</td>
                            <td className="px-2">{word.wreath_word}</td>
                            <td className="px-2 text-xs text-gray3">{word.search_word}</td>
                            <td className="flex items-center justify-center h-[50px]">
                                <Toggle
                                    onToggle={e => {
                                        e.stopPropagation();
                                        handleChangeStatus(word.word_idx);
                                    }}
                                    className="pl-2"
                                    onLabel="노출"
                                    offLabel="숨김"
                                    isOn={word.status}
                                    disabled={level === 7}
                                />
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={7} className="text-center">
                            <div className="flex flex-col items-center gap-5 py-4 mt-52">
                                <Empty />
                                <p className="text-grayicon text-lg">등록된 내역이 없습니다.</p>
                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default WordTable;
